import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddBrand from "../AddOffer";

const InitMiddlewareAddBrand:React.FC<any> = (props) => {
  const { addOfferRes = {}, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.offers ?? {}
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Offers",
        link: `/offers`,
      },
      {
        label: "Add new offers",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);
  
  useEffect(() => {
    if (isSuccess && addOfferRes?.success === true) {
      navigate("/offers");
    }
  }, [isSuccess, addOfferRes, navigate]);

  // if (isSuccess && addOfferRes?.data?.success === true) {
  //   navigate("/offers")
  //   return null;
  // } else {
  //   return <AddBrand {...props} />;
  // }
  return <AddBrand {...props} />;
};

export default InitMiddlewareAddBrand;
